export const debounce = (cb: (...args: any) => void, timeout = 200) => {
    let timer: NodeJS.Timeout | undefined;

    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(cb, timeout, ...args);
    }
}